

/**
 * Sorts an array of objects by a number property.
 *
 * @param {Object} a - The first object to compare.
 * @param {Object} b - The second object to compare.
 * @param {string} prop - The property name containing the date string.
 * @param {string} direction - The direction of the sort ('asc' for ascending, 'desc' for descending).
 * @returns {number} - Returns -1 if a < b, 1 if a > b, and 0 if equal.
 */
function sortNumber(a, b, prop, direction) {
    if (direction === 'asc') {
        if (Number(a[prop]) < Number(b[prop])) {
            return -1;
        }
        if (Number(a[prop]) > Number(b[prop])) {
            return 1;
        }
        return 0;
    } else {
        if (Number(a[prop]) > Number(b[prop])) {
            return -1;
        }
        if (Number(a[prop]) < Number(b[prop])) {
            return 1;
        }
        return 0;
    }
}

/**
 * Sorts an array of objects by a string property.
 *
 * @param {Object} a - The first object to compare.
 * @param {Object} b - The second object to compare.
 * @param {string} prop - The property name containing the date string.
 * @param {string} direction - The direction of the sort ('asc' for ascending, 'desc' for descending).
 * @returns {number} - Returns -1 if a < b, 1 if a > b, and 0 if equal.
 */
function sortString(a, b, prop, direction) {
    if (direction === 'asc') {
        if (a[prop] < b[prop]) {
            return -1;
        }
        if (a[prop] > b[prop]) {
            return 1;
        }
        return 0;
    } else {
        if (a[prop] > b[prop]) {
            return -1;
        }
        if (a[prop] < b[prop]) {
            return 1;
        }
        return 0;
    }
}

/**
 * Sorts an array of objects by a date property.
 *
 * @param {Object} a - The first object to compare.
 * @param {Object} b - The second object to compare.
 * @param {string} prop - The property name containing the date string.
 * @param {string} direction - The direction of the sort ('asc' for ascending, 'desc' for descending).
 * @returns {number} - Returns -1 if a < b, 1 if a > b, and 0 if equal.
 */
function sortDate(a, b, prop, direction) {
    if(direction === 'asc') {
        if (Date.parse(a[prop]) < Date.parse(b[prop])) {
            return -1;
        }
        if (Date.parse(a[prop]) > Date.parse(b[prop])) {
            return 1;
        }
        return 0;
    } else {
        if (Date.parse(a[prop]) > Date.parse(b[prop])) {
            return -1;
        }
        if (Date.parse(a[prop]) < Date.parse(b[prop])) {
            return 1;
        }
        return 0;
    }
}

export { 
    sortNumber,
    sortString,
    sortDate 
};